<script>
  export let value;
</script>

<div class='standing-append'>
  <div class='standing-append-g'> {value.g} </div>

  <div class='standing-append-w'> {value.w} </div>

  <div class='standing-append-l'> {value.l} </div>

  <div class='standing-append-t'> {value.t} </div>
</div>

<style>
  .standing-append {
    display: flex;
    gap: 10px;
  }

  .standing-append-g {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 30px;
    height: 20px;
  }

  .standing-append-w {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 30px;
    height: 20px;

    font-weight: bold;
  }

  .standing-append-l {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 30px;
    height: 20px;

    font-weight: bold;
  }

  .standing-append-t {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 30px;
    height: 20px;

    color: var(--grey-5);
  }

  :global(body.dark) .standing-append-t {
    color: var(--grey-6);
  }

  @media only screen and (max-width: 500px) {
    .standing-append-g {
      display: none;
    }
  }
</style>
